import React, { useState } from "react"
import "./hprogramme.css"

const modules = [
  {
    number: "01",
    title: "Signature Programme Introduction",
    icon: "fa fa-graduation-cap",
    topics: [
      "Trading Platform Orientation",
      "Psychology of Trading",
      "Trading Terminologies",
      "Demand and Supply – Relating Terms",
      "Order Flow",
      "Market Participants",
      "Technical and Fundamental Analysis",
    ],
  },
  {
    number: "02",
    title: "Charts and Candles",
    icon: "fa fa-chart-bar",
    topics: [
      "Chart Analysis",
      "The 4 Formations of a Chart",
    ],
  },
  {
    number: "03",
    title: "Chart Candles",
    icon: "fa fa-fire",
    topics: [
      "Candles and Candle Analysis",
      "Balance and Imbalance",
    ],
  },
  {
    number: "04",
    title: "Proximal and Distal Lines",
    icon: "fa fa-ruler-combined",
    topics: [
      "Proximal and Distal Lines Positioning",
    ],
  },
  {
    number: "05",
    title: "Zones",
    icon: "fa fa-layer-group",
    topics: [
      "Zone Identification and Zone Process",
      "Zone Analysis — Strong & Weak Zones",
      "Proximal and Distal Line Placement for Zones",
    ],
  },
  {
    number: "06",
    title: "Trends and Trend Analysis",
    icon: "fa fa-arrow-trend-up",
    topics: [
      "Trend Overview, Elements and Identification",
      "Impulse and Correction",
      "Swings and Segments",
      "Uptrend / Downtrend Formation, Continuation and Termination",
      "Trend and Zone Combination",
    ],
  },
]

const liveMarket = [
  { icon: "fa fa-broadcast-tower",    label: "Live Trading Sessions",          desc: "Real-time trade execution and explanation by experienced traders.",               url: "/live" },
  { icon: "fa fa-laptop-code",        label: "Trading Simulations",            desc: "Practice accounts with guided feedback to build confidence.",                     url: "/features/trading-simulations" },
  { icon: "fa fa-calendar-week",      label: "Market Reviews",                 desc: "Weekly and daily breakdowns of key market moves.",                                url: "https://www.forexfactory.com/" },
  { icon: "fa fa-cogs",               label: "Strategy Development",           desc: "Building personalised trading systems tailored to your style.",                   url: "/courses" },
  { icon: "fa fa-user-tie",           label: "One-on-One Coaching",            desc: "Tailored support for struggling or advanced traders.",                            url: "/contact" },
  { icon: "fa fa-book",               label: "Trading Journals & Performance", desc: "Data-driven self-improvement through structured journaling.",                     url: "https://www.forexfactory.com/" },
  { icon: "fa fa-balance-scale-right",label: "Risk-to-Reward Estimates",       desc: "Learn to calculate and manage every trade's risk before entry.",                  url: "/courses" },
]

const HProgramme = () => {
  const [active, setActive] = useState(0)

  return (
    <>
      {/* ── Signature Programme ── */}
      <section className="hprog padding">
        <div className="container">
          <div className="hprog-header">
            <p className="hprog-eyebrow">OUR SIGNATURE COURSE</p>
            <h2>The Rovers Access Signature Programme</h2>
            <p className="hprog-sub">
              A comprehensive, structured curriculum that takes you from zero to confident trader —
              covering every essential rule and skill needed for Forex, Futures and Options.
            </p>
          </div>

          <div className="hprog-body">
            {/* Left — module tabs */}
            <div className="hprog-tabs">
              {modules.map((m, i) => (
                <button
                  key={i}
                  className={`hprog-tab${active === i ? " active" : ""}`}
                  onClick={() => setActive(i)}
                >
                  <span className="tab-num">{m.number}</span>
                  <span className="tab-title">{m.title}</span>
                  <i className={`fa fa-chevron-right tab-arrow`}></i>
                </button>
              ))}
            </div>

            {/* Right — active module detail */}
            <div className="hprog-detail">
              <div className="detail-icon">
                <i className={modules[active].icon}></i>
              </div>
              <div className="detail-tag">Module {modules[active].number}</div>
              <h3>{modules[active].title}</h3>
              <ul className="detail-topics">
                {modules[active].topics.map((t, i) => (
                  <li key={i}>
                    <i className="fa fa-check-circle"></i>
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
              <div className="detail-badge">
                <i className="fa fa-award"></i>
                Certificate awarded on completion
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Live Market Bridge ── */}
      <section className="hbridge padding">
        <div className="container">
          <div className="hprog-header">
            <p className="hprog-eyebrow">BEYOND THE CLASSROOM</p>
            <h2>Bridging Theory and Live Markets</h2>
            <p className="hprog-sub">
              We don't just teach — we immerse you in real trading environments with the tools,
              sessions, and mentorship that turn knowledge into skill.
            </p>
          </div>
          <div className="hbridge-grid">
            {liveMarket.map((item, i) => {
              const isExternal = item.url?.startsWith("http")
              const Tag        = "a"
              return (
                <a
                  key={i}
                  href={item.url}
                  className="hbridge-card"
                  target={isExternal ? "_blank" : undefined}
                  rel={isExternal ? "noreferrer" : undefined}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <div className="hbridge-icon">
                    <i className={item.icon}></i>
                  </div>
                  <h4>{item.label}</h4>
                  <p>{item.desc}</p>
                  {isExternal && (
                    <span style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginTop: 6, display: "flex", alignItems: "center", gap: 4 }}>
                      <i className="fa fa-external-link-alt"></i> {new URL(item.url).hostname}
                    </span>
                  )}
                </a>
              )
            })}
          </div>
        </div>
      </section>
    </>
  )
}

export default HProgramme
